<template>
<ul class="block">
  <li
    v-for="(answer, index) in answers"
    :key="index"
    class="mt-2 columns is-mobile is-1"
  >
    <div class="column is-2 has-text-weight-semibold">
      <span>{{ answerLabels[index] }}</span>
      <correct-status
        v-if="correctAnswer == index"
        :is-correct="correctAnswer == index"
        class="ml-2"
      ></correct-status>
    </div>
    <html-content
      class="column"
      :body="answer"
    ></html-content>
  </li>
</ul>
</template>
<script>
import HtmlContent from '@/components/atoms/HtmlContent'
import CorrectStatus from '@/components/atoms/CorrectStatus'

export default{
  name: 'SelectTypeAnswersContent',

  components: {
    HtmlContent,
    CorrectStatus,
  },

  props: {
    answers: {
      type: Array,
      default: [],
    },

    correctAnswer: {
      type: Number,
      default: null,
    },
  },

  data(){
    return {
      answerLabels: ['A', 'B', 'C', 'D'],
    }
  },

  computed: {
  },

  watch: {
  },

  created() {
  },

  destroyed() {
  },

  methods: {
  },
}
</script>

